.Main {
  padding: var(--padding);
}

.Item {
  border-bottom: 1px solid #00000033;
}

.Top {
  display: grid;
  grid-template-columns: var(--left-column) minmax(0, 1fr) min-content;
  gap: var(--space-s);
  padding: calc(10.7692px + 2.5641vw) 0;
  cursor: pointer;
}

.Bottom {
  display: none;
  padding: var(--space-l) 0;
  gap: var(--space-m) var(--space-s);
  grid-template-columns: var(--left-column) minmax(0, 1fr);

  a:hover {
    opacity: 0.8;
  }

  p:not(:last-child) {
    padding-block-end: 1em;
  }
}

.Open .Bottom {
  display: grid;
}

.Links {
  display: flex;
  gap: var(--space-s);
}

.Link {
  text-transform: uppercase;

  &:hover {
    opacity: 0.5;
  }

  &:active {
    transform: scale(0.95);
  }
}

.Location {
  font-size: var(--text-s);
  line-height: 1;
}

.Title {
  font-size: var(--text-xl);
  line-height: 0.835;
}

.Icon {
  font-size: var(--text-s);
  align-self: end;
  line-height: 0.8;
  margin-inline-start: auto;
}

.Past {
  font-size: var(--text-s);
  line-height: normal;
}

@media (min-width: 768px) {
  .Bottom {
    padding-inline-start: calc(var(--left-column) + var(--space-s));
  }
}
